"use client";

import { motion } from "framer-motion";
import "./animated-gradient-bg.css";

export default function AnimatedGradientBg() {
  const gradients = [
    // Purple to teal
    "linear-gradient(135deg, #2d1b69 0%, #11998e 100%)",
    // Purple to deep blue
    "linear-gradient(135deg, #8e2de2 0%, #4a00e0 100%)",
    // Dark blue to red
    "linear-gradient(135deg, #0f3460 0%, #e94560 100%)",
    // Teal to green
    "linear-gradient(135deg, #134e5e 0%, #71b280 100%)",
    // Back to purple/teal
    "linear-gradient(135deg, #2d1b69 0%, #11998e 100%)",
  ];

  return (
    <motion.div
      className="r2-animated-gradient-bg"
      animate={{
        background: gradients,
      }}
      transition={{
        duration: 8,
        repeat: Number.POSITIVE_INFINITY,
        ease: "easeInOut",
        delay: 0.5,
      }}
    />
  );
}
